export const getRegisterStatistics = (state) => state.registerStatistics.statistics?.data
